import CustomBottomSheet from 'components/bottomSheet';
import AuctionDetail from 'components/productDetail/auction';
import Header from 'modules/header/wholesaler/main';
import ViolationModal from 'modules/violationModal';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {ViolationReportDetailItems} from '../constants';

const AuctionDetailPage = () => {
  const [openViolationModal, setOpenViolationModal] = useState<boolean>(false);
  const location = useLocation();
  const {productDetail, isLoading} = useGetPostDetail(location.state.guid);
  const isFarm = location.pathname.includes('farm');
  return (
    <>
      {!isLoading && productDetail && (
        <>
          <Header title={productDetail.title} />
          <AuctionDetail
            post={productDetail}
            app="market"
            setOpenViolationModal={setOpenViolationModal}
          />
        </>
      )}
      <CustomBottomSheet
        isOpen={openViolationModal}
        onDismiss={() => setOpenViolationModal(false)}
      >
        <ViolationModal
          open={openViolationModal}
          handleClose={() => setOpenViolationModal(false)}
          items={ViolationReportDetailItems}
          guid={location.state.guid}
          object_type="market"
          isFarm={isFarm}
        />
      </CustomBottomSheet>
    </>
  );
};

export default AuctionDetailPage;
